import React, {Component} from 'react'
import {connectSearchBox} from 'react-instantsearch-dom'
import {CloseIcon, SearchIcon} from '../../../icons'
import {isCa} from '@/scripts/util/countryCheck'
import {getShopifyAlgoliaIndex} from '@/scripts/components/algolia/config'

const LoadingIndicator = () => {
    return <div className="algolia-loading-indicator"></div>
}

class SearchBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showReset: false,
            value: this.props.searchValue,
            showLoadingIndicator: false
        }

        this.results = this.props.results

        if (this.props.searchValue && this.props.searchValue !== ``) {
            this.props.refine(this.props.searchValue)
        }

        this.timerId = null
        this.onChangeDebounced = this.onChangeDebounced.bind(this)

        this.algoliaIndex = getShopifyAlgoliaIndex()
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.currentRefinement !== `` &&
            prevProps.currentRefinement === ``
        ) {
            this.setState({
                showReset: true,
            })
            setTimeout(() => {
                let element = document.querySelector(`.algolia-search-results`)
                if (element != null) {
                    element.classList.add(`active`)
                }
            }, 300)
        }
    }

    onChangeDebounced(event) {
        const {refine, delay} = this.props
        const value = event.currentTarget.value

        this.setState({
            showLoadingIndicator: true,
        })

        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
            refine(value)
            this.setState({
                showLoadingIndicator: false,
            })
            // Pass up the Value to the Parent Component
            this.props.onChange(value)
        }, delay)

        this.setState({
            value: value
        })
    }

    resetSearch() {
        const element = document.querySelector(`.algolia-search-results`)

        this.props.refine(``)

        element && element.classList.remove(`active`)

        this.setState({
            showReset: false,
            value: ``,
        })

        // Reset the Dropdown Value List
        this.props.onChange(null)
    }

    checkOneResult() {
        const totalResults = this.props.results.reduce(
            (total, current) => total + current.nbHits,
            0
        )
        return totalResults === 1
    }

    searchTerm(e) {
        e.preventDefault()

        let url = `/search?Search=""&view=product`

        if (this.checkOneResult()) {

          let {index, hits} = this.props.results.find(result => {
                return result.nbHits === 1
            })

            switch (index) {
                case this.algoliaIndex.products:
                    url = `/products/${hits[0].handle}`
                    break
                case this.algoliaIndex.collections:

                    url = `/collections/${hits[0].handle}`
                    break
                case this.algoliaIndex.articles:
                    url = `/blogs/${hits[0].blog.handle}/${hits[0].handle}`
                    break
            }
        } else if (this.state.value !== ``) {
            url = `/search?Search="${this.state.value}"&view=product`
        }
        if (isCa() && window.Shopify.locale !== `en`) {
            url = `/fr` + url
        }
        window.location.href = url
    }

    render() {
        const {value, showReset, showLoadingIndicator} = this.state

        return (
            <div className={`algolia-search-bar`}>
                <div className="form">
                <form
                            noValidate
                            action=""
                            role="search"
                            className={`search-input-form`}
                            onSubmit={e => this.searchTerm(e)}
                        >
                    <div className="input wide">
                        <div>
                            <input
                                type="search"
                                value={value}
                                onChange={this.onChangeDebounced}
                                placeholder={
                                    document.querySelector(`.sticky-header__inner`)?.getAttribute(`data-placeholder`) || 
                                    `Search from 6500+ products`
                                }
                                className="auto-focus"
                            />
                            {showLoadingIndicator && <LoadingIndicator/>}
                        </div>
                    </div>

                    <div className={`icon-button-wrap flex v-center`}>
                        <div
                            className={`icon-button icon-button--close flex v-center h-center ${
                                showReset ? `active` : `inactive`
                            }`}
                            data-hide-results
                            onClick={() => this.resetSearch()}
                        >
                            <a className="fancy-button"></a>
                            <CloseIcon/>
                        </div>
                        <button
                            className="icon-button icon-button--submit flex v-center h-center"
                            onClick={e => this.searchTerm(e)}
                        >
                            <SearchIcon/>
                        </button>
                    </div>
                    </form>
                </div>
                <div className={`algolia-search-close-ol ${
                                showReset ? `active` : `inactive`
                            }`} onClick={() => this.resetSearch()}>
                </div>
            </div>
        )
    }
}

const CustomSearchBar = connectSearchBox(SearchBar)

export default CustomSearchBar
